export default IconSailboatOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-sailboat-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1" />
  <path d="M4 18l-1 -3h12m4 0h2l-.506 1.517" />
  <path d="M11 11v1h1m4 0h2l-7 -9v4" />
  <path d="M7.713 7.718l-1.713 4.282" />
  <path d="M3 3l18 18" />
</svg>`;